import { render, staticRenderFns } from "./o-image-cropper.vue?vue&type=template&id=1793fbf6&scoped=true&"
import script from "./o-image-cropper.vue?vue&type=script&lang=js&"
export * from "./o-image-cropper.vue?vue&type=script&lang=js&"
import style0 from "./o-image-cropper.vue?vue&type=style&index=0&id=1793fbf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1793fbf6",
  null
  
)

export default component.exports